<template>
  <div id="contact">
    <section class="section pb-0">
      <!-- Content -->
      <div class="container">
        <div class="row">
          <div class="col-md-2 text-md-left" >
            <!-- Title -->
            <h6 class="title">
              Contact form and information
            </h6>
          </div>
          <div class="col-md-9 offset-md-1 text-md-left">
            <!-- Heading -->
            <h3 class="mb-4">
              Have questions? Send us a
              <span class="text-primary">message</span>
            </h3>

            <!-- Subheading -->
            <p class="text-muted mb-5">
              Drop us an email at<br/>
              <a
                class="text-primary"
                href="
              mailto:contact@ezcli.com"
                >contact@ezcli.com</a
              >
              <br/>we will get back to you as soon as
              possible.
            </p>

            <!-- Form -->
            <!-- <form>
              <div class="form-row">
                <div class="form-group col-md-8">
                  
                  <label>Name</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control order-1"
                      name="contact-name"
                    />
                    <div class="input-group-append order-0">
                      <div class="input-group-text">
                        <svg
                          class="input-group-icon icon-offset icon icon-person"
                          viewBox="0 0 100 100"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="m67.078 55.59c5.9141-4.9141 9.6914-12.32 9.6914-20.594 0-14.762-12.012-26.77-26.77-26.77-14.762 0-26.77 12.008-26.77 26.77 0 8.2734 3.7734 15.68 9.6875 20.594-12.043 6.4102-19.691 19.633-19.691 34.422 0 0.97266 0.78906 1.7617 1.7617 1.7617 0.97266 0 1.7617-0.78906 1.7617-1.7617 0-14.145 7.6406-26.668 19.477-32.102 4.0273 2.4297 8.7305 3.8555 13.77 3.8555 5.0273 0 9.7227-1.4219 13.746-3.8438 11.855 5.4375 19.504 17.906 19.504 32.09 0 0.97266 0.78906 1.7617 1.7617 1.7617 0.97266 0 1.7617-0.78906 1.7617-1.7617 0.003907-14.824-7.6367-28.004-19.691-34.422zm-17.078 2.6523c-12.816 0-23.242-10.43-23.242-23.246-0.003906-12.816 10.426-23.246 23.242-23.246 12.82 0 23.246 10.426 23.246 23.242 0 12.82-10.43 23.25-23.246 23.25z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-8">
                  
                  <label>Company</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control order-1"
                      name="contact-name"
                    />
                    <div class="input-group-append order-0">
                      <div class="input-group-text">
                        <svg
                          class="input-group-icon icon-offset icon icon-person"
                          viewBox="0 0 100 100"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="m41.711 59.043v-7.6758c2.5469-2.2578 4.2539-5.3164 4.8398-8.6719 1.3281-0.15625 2.3398-1.8242 2.3398-3.9258 0-2.0586-0.97266-3.7031-2.2617-3.9141 2.0859-5.1523 2.3359-9.2305 0.73438-12.125v-0.003907c-1.0547-1.8711-2.8672-3.1992-4.9688-3.6367-0.44141-0.10938-10.734-2.5742-15.859 3.9219-0.85156-0.15625-3.1367-0.38281-4.5117 1.2188-1.5938 1.8516-1.3242 5.4258 0.80859 10.625-1.2891 0.21484-2.2617 1.8555-2.2617 3.9141 0 2.082 0.99219 3.7344 2.3398 3.9219 0.58203 3.3555 2.2891 6.418 4.8398 8.6758v7.6758c-5.1055 0.40234-17.699 6.4453-19.637 7.9961-2.1914 1.7539-2.2109 12.668-2.207 13.906 0.003906 0.27344 0.22656 0.49609 0.5 0.49609h56.648c0.27344 0 0.49609-0.22266 0.5-0.49609 0.003906-1.2383-0.011719-12.148-2.2031-13.906-1.9414-1.5508-14.535-7.5977-19.641-7.9961zm-34.805 21.398c0.019531-4.5312 0.51172-11.566 1.8281-12.621 1.9023-1.5234 15.078-7.8008 19.512-7.8008h0.003906c0.27734 0 0.5-0.22266 0.5-0.5v-8.3867c0-0.15234-0.066406-0.29297-0.18359-0.39062-2.5703-2.2031-4.2539-5.2656-4.7422-8.6133-0.046875-0.25781-0.27734-0.43359-0.53906-0.41797l-0.16797-0.003907c-0.73047 0-1.5469-1.207-1.5469-2.9375 0-1.9727 1.0273-3.2227 1.8516-2.875 0.19141 0.078125 0.40625 0.035157 0.55078-0.10938 0.14453-0.14453 0.18359-0.36328 0.10547-0.55078-2.8164-6.5234-2.2617-9.2305-1.3008-10.352 1.2734-1.4844 3.8125-0.84375 3.8359-0.83594v0.003906c0.19922 0.050781 0.40625-0.023437 0.53125-0.1875 4.6484-6.2812 14.906-3.8281 15.051-3.793 1.8164 0.39453 3.3789 1.5391 4.3008 3.1562 1.5117 2.7578 1.1367 6.8008-1.1133 12.012v-0.003906c-0.082031 0.1875-0.039062 0.40625 0.10547 0.55078 0.14453 0.14453 0.35938 0.1875 0.54688 0.10938 0.82031-0.34766 1.8516 0.90234 1.8516 2.875 0 1.7305-0.81641 2.9375-1.5469 2.9375l-0.15625 0.003907h0.003906c-0.26562-0.03125-0.51172 0.15234-0.55469 0.41797-0.48828 3.3477-2.1719 6.4102-4.7383 8.6133-0.11719 0.097656-0.1875 0.23828-0.18359 0.39062v8.3867c0 0.27734 0.22266 0.5 0.5 0.5 4.4336 0 17.609 6.2773 19.512 7.8008 1.3164 1.0547 1.8125 8.0938 1.8281 12.621zm87.184 0.50391c0 0.27344-0.22266 0.49609-0.5 0.49609h-23.309c-0.27344 0-0.5-0.22266-0.5-0.5s0.22656-0.5 0.5-0.5h22.809c-0.019532-3.8555-0.43359-9.7617-1.5312-10.641-1.6172-1.2969-12.836-6.6406-16.605-6.6406-0.27734 0-0.50391-0.22266-0.50391-0.5v-7.1602c0-0.14844 0.066406-0.29297 0.18359-0.38672 2.1797-1.8711 3.6055-4.4648 4.0195-7.3086 0.042968-0.26563 0.28516-0.44922 0.55078-0.41797 0.003906 0 0.12109-0.003907 0.125-0.003907 0.58984 0 1.2461-1 1.2461-2.4336 0-1.6211-0.82422-2.6602-1.4805-2.3867l0.003906 0.003906c-0.1875 0.078125-0.40625 0.035156-0.55078-0.10938-0.14062-0.14453-0.18359-0.36328-0.10156-0.55078 1.9102-4.4258 2.2305-7.8516 0.95313-10.184-0.77734-1.3594-2.0898-2.3242-3.6211-2.6562-0.12891-0.03125-8.8359-2.1094-12.773 3.2109v-0.003906c-0.12109 0.16406-0.33203 0.23828-0.53125 0.1875-0.019531-0.007813-2.1445-0.53906-3.1992 0.69141-0.80469 0.9375-1.2656 3.2227 1.1211 8.7539 0.082031 0.1875 0.039063 0.40625-0.10547 0.55078-0.14062 0.14453-0.35937 0.1875-0.54687 0.10938-0.65234-0.27734-1.4805 0.76172-1.4805 2.3867 0 1.4336 0.65625 2.4336 1.2461 2.4336l0.14063 0.003906 0.003906-0.003906c0.25391-0.007813 0.48047 0.16797 0.53516 0.41797 0.41406 2.8438 1.8398 5.4375 4.0195 7.3086 0.11719 0.09375 0.18359 0.23828 0.18359 0.38672v5.8594c0 0.27344-0.22266 0.5-0.5 0.5s-0.5-0.22656-0.5-0.5v-5.625c-2.1641-1.9219-3.6133-4.5195-4.1211-7.3711-1.1562-0.19922-2.0078-1.625-2.0078-3.4102 0-1.7461 0.8125-3.1484 1.9023-3.3945-1.8008-4.4219-2.0156-7.4688-0.64453-9.0625 1.0273-0.99219 2.4844-1.3984 3.875-1.0703 4.4102-5.5391 13.203-3.4297 13.582-3.3359v-0.003906c1.8164 0.37891 3.3789 1.5234 4.2891 3.1406 1.3672 2.4766 1.168 5.9492-0.58984 10.328 1.0898 0.24609 1.9023 1.6484 1.9023 3.3945 0 1.8008-0.86328 3.2383-2.0078 3.4141v0.003907c-0.50781 2.8477-1.9609 5.4453-4.1211 7.3672v6.4492c4.4141 0.39453 15.086 5.5156 16.734 6.8359 1.8555 1.4883 1.9141 10.195 1.9102 11.926z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-8">
                  
                  <label>Email address</label>
                  <div class="input-group">
                    <input
                      type="email"
                      class="form-control order-1"
                      name="contact-email"
                    />
                    <div class="input-group-append order-0">
                      <div class="input-group-text">
                        <svg
                          class="input-group-icon icon-offset icon icon-envelope"
                          viewBox="0 0 100 100"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="m15 23c-3.8594 0-7 3.1406-7 7v40c0 3.8594 3.1406 7 7 7h70c3.8594 0 7-3.1406 7-7v-40c0-3.8594-3.1406-7-7-7zm0 2h70c1.2266 0 2.3242 0.46875 3.1875 1.1875l-34.531 29.406c-2.2148 1.8867-5.1602 1.8867-7.375 0l-34.469-29.406c0.86328-0.71875 1.9609-1.1875 3.1875-1.1875zm-4.4688 2.7812 34.469 29.344c2.9062 2.4727 7.0312 2.4727 9.9375 0l34.531-29.344c0.33594 0.67578 0.53125 1.4062 0.53125 2.2188v40c0 2.7891-2.2109 5-5 5h-70c-2.7891 0-5-2.2109-5-5v-40c0-0.8125 0.19531-1.543 0.53125-2.2188z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group col-md-8">
                  
                  <label>Phone number</label>
                  <div class="input-group">
                    <input
                      type="email"
                      class="form-control order-1"
                      name="contact-email"
                    />
                    <div class="input-group-append order-0">
                      <div class="input-group-text">
                        <svg
                          class="input-group-icon icon-offset icon icon-envelope"
                          viewBox="0 0 100 100"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            transform="translate(3 3)"
                            d="m90.441 73.82-15.363-10.52-0.078125-0.070312c-2.8203-1.4102-5.9297-0.64062-8.7617 2.1602-6.6914 5.1797-10.078 3.8789-14.73-0.76172l-16.102-16.102c-4.6406-4.6484-5.9414-8-0.76172-14.73 2.8008-2.8281 3.5703-5.9414 2.1602-8.7617l-10.625-15.477c-3.5898-4.3906-6-5.3789-9.6016-3.9219-6.1016 2.5-10 6.8789-11.16 12.68-2.5781 12.391 6.6992 30.191 26.129 50.148 17.762 17.297 33.824 26.535 45.875 26.535 1.4297 0.011719 2.8555-0.12891 4.2578-0.42188 5.8008-1.1992 10.18-5.0586 12.68-11.16 1.4609-3.5781 0.48047-6.0078-3.918-9.5977zm2.0586 8.8516c-2.2617 5.5195-6 8.8711-11.219 10-11.551 2.3281-29.172-6.9727-48.281-25.621-18.699-19.16-28-36.781-25.621-48.332 1.0781-5.1914 4.4297-9 10-11.219 0.62891-0.30078 1.3086-0.47266 2-0.51172 1.3594 0 2.8398 0.87109 5.2109 3.7695l10.41 15.242c1 2.0508 0.37109 4.2109-1.8594 6.4414l-0.078125 0.089844c-6.0625 7.7695-4.2422 12.27 0.9375 17.41l16.059 16.059c5.1406 5.1406 9.6406 6.9414 17.422 0.89062l0.089843-0.078125c2.2305-2.1914 4.4297-2.8125 6.4297-1.8125l15.199 10.398c4.3906 3.6016 4.1797 5.1406 3.3008 7.2734z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12">
                  <label>Your comments</label>
                  <textarea
                    class="form-control"
                    name="contact-message"
                    rows="7"
                  ></textarea>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <button type="submit" class="btn btn-outline-primary">
                    Send message
                  </button>
                  <button type="reset" class="btn btn-link">
                    Reset form
                  </button>
                </div>
              </div>
            </form> -->
          </div>
        </div>
        <!-- / .row -->
      </div>
      <!-- / .container -->
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style>
.img-small {
  width: 40%;
}
</style>
